import React from 'react';
import { Provider, observer } from 'mobx-react';

import Content from './Content';
import Logo from './Logo';
import Centered from './Centered';
import Details from './Details';
import Verified from './Verified';
import Name from './Name';
import AccountNumber from './AccountNumber';
import EditPencil from './EditPencil';

export const creditCardHeight = 8;

export default observer(({ creditCard, onEdit, isBusy }) => (
  <Provider creditCard={creditCard}>
    <Details editor={!!onEdit} isBusy={isBusy} height={creditCardHeight}>
      <Logo />
      <Centered>
        <Content>
          <Name>{creditCard.name}</Name>
          <AccountNumber>
            {['visa', 'mastercard', 'discover'].includes(creditCard.cc_type)
              ? `#### #### #### ${creditCard.number.slice(-4)}`
              : `#### ###### #${creditCard.number.slice(-4)}`}
          </AccountNumber>
          {creditCard.is_verified && <Verified />}
        </Content>
      </Centered>
      {onEdit && <EditPencil onClick={onEdit} />}
    </Details>
  </Provider>
));
